/* eslint-disable */

// referenced from https://github.com/jugglinmike/srcdoc-polyfill/blob/master/srcdoc-polyfill.js
export const srcDocSet = (iframe, content = '') => {
  let jsUrl;

  if (!iframe || !iframe.getAttribute) {
    return;
  }

  iframe.setAttribute('srcdoc', content);
  jsUrl = "javascript: window.frameElement.getAttribute('srcdoc');";
  if (iframe.contentWindow) {
    iframe.contentWindow.location = jsUrl;
  }

  iframe.setAttribute('src', jsUrl);
};

/* eslint-enable */
